import React, { useEffect } from 'react';
import './App.css';
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from 'react-router-dom';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problem from './components/Problem';
import How from './components/How';
import Footer from './components/Footer';
import EarlyAccess from './components/EarlyAccess';
import Experience from './components/Experience';
import DeviceMakers from './components/DeviceMakers';
import TodayNextVision from './components/TodayNextVision';

import Technology from './pages/Technology';
import Research from './pages/Research';
import ForDeviceMakers from './pages/ForDeviceMakers';
import Vision from './pages/Vision';

import { Toaster } from './components/ui/toaster';


/*
 * Handles URLs containing a hash such as:
 *
 * /#experience
 * /#device-makers
 * /#contact
 *
 * This is especially important when navigating from
 * another page back to a section on the homepage.
 */
const ScrollToHash = () => {
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) {
            window.scrollTo({
                top: 0,
                behavior: 'instant',
            });

            return;
        }

        const hash = decodeURIComponent(
            location.hash.substring(1)
        );

        /*
         * Give React one frame to render the destination
         * before attempting to find the section.
         */
        const timer = window.setTimeout(() => {
            const element = document.getElementById(hash);

            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }, 50);

        return () => {
            window.clearTimeout(timer);
        };
    }, [location.pathname, location.hash]);

    return null;
};


const Landing = () => (
    <>
        <Hero />

        <Problem />

        <Experience />

        <How />

        <TodayNextVision />

        <DeviceMakers />

        <EarlyAccess />
    </>
);


const PageLayout = ({ children }) => (
    <div className="min-h-screen bg-[#05070b] text-white antialiased">

        <Navbar />

        <main>
            {children}
        </main>

        <Footer />

        <Toaster />

    </div>
);


function App() {
    return (
        <BrowserRouter>

            <ScrollToHash />

            <PageLayout>

                <Routes>

                    <Route
                        path="/"
                        element={<Landing />}
                    />

                    <Route
                        path="/technology"
                        element={<Technology />}
                    />

                    <Route
                        path="/research"
                        element={<Research />}
                    />

                    <Route
                        path="/for-device-makers"
                        element={<ForDeviceMakers />}
                    />

                    <Route
                        path="/vision"
                        element={<Vision />}
                    />

                </Routes>

            </PageLayout>

        </BrowserRouter>
    );
}


export default App;